<template>
  <div class="card h-100">
    <div
      class="card-body text-center d-flex flex-column justify-content-between align-items-center"
    >
      <div>
        <div class="mt-2 position-relative">
          <img
            class="avatar rounded-circle"
            src="/img/persons/avatar-muted.png"
            :alt="user.name"
          />
          <icon-male
            v-if="user.gender == 'M'"
            class="position-absolute start-50 bottom-0 ms-3"
            alt="Male"
          />
          <icon-female
            v-if="user.gender == 'F'"
            class="position-absolute start-50 bottom-0 ms-3"
            alt="Female"
          />
        </div>
        <div class="mt-2 text-sm text-bold">{{ user.name }}</div>
        <div class="mt-1 text-uppercase text-muted text-xs">
          {{ user.platoon_name }} / {{ user.section_name }}
        </div>
      </div>

      <div>
        <h3
          class="my-4 text-xxl text-bold"
          :class="`header-color-${candidate.confidence}`"
        >
          <!-- {{ candidate.profile_score }}% -->
            <!-- After report uncomment above and delete below -->
            {{ candidate.wellness_score }} %
        </h3>
        <div v-if="showDna && false" class="d-flex justify-content-center">
          <icon-dna class="me-2 align-self-center" style="padding: 2px" />
          <argon-progress-with-alert
            style="width: 9.5rem; padding-top: 2px"
            color="dna"
            :percentage="candidate.dna_score"
            :end-text="candidate.dna_score > 0 ? candidate.dna_score + '%' : ''"
            :tooltip-text="
              candidate.dna_score <= 0
                ? 'The profile score is reduced due to unavailability of DNA data. Schedule for a DNA test for more accurate profiling.'
                : ''
            "
          />
        </div>
        <div class="d-flex justify-content-center">
          <icon-wellness class="me-2 align-self-center" style="padding: 1px" />
          <argon-progress-with-alert
            style="width: 9.5rem; padding-top: 2px"
            color="wellness"
            :percentage="candidate.wellness_score"
            :end-text="
              candidate.wellness_score > 0 ? candidate.wellness_score + '%' : ''
            "
            :tooltip-text="
              candidate.wellness_score <= 0
                ? 'The profile score is reduced due to unavailability of wellness data. Fitness band needs to be worn for at least a month for more accurate profiling.'
                : ''
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconDna from "@/shared/Controls/Icons/IconDna.vue";
import IconWellness from "@/shared/Controls/Icons/IconWellness.vue";
import IconMale from "@/shared/Controls/Icons/IconMale.vue";
import IconFemale from "@/shared/Controls/Icons/IconFemale.vue";

import ArgonProgressWithAlert from "@/shared/Controls/ArgonProgressWithAlert.vue";

export default {
  components: {
    IconDna,
    IconWellness,
    IconMale,
    IconFemale,
    ArgonProgressWithAlert,
  },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    showDna: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  width: 64px;
  height: 64px;
}
</style>
